export default {
    props: ['examContent','goodsId','fenshulll','testTitle',],
    data() {
        return {
            tfChoiceanswer: [],
            singleChoiceanswer: [],
            multipleChoiceanswer: [],
            fillanswer: [],
            fillInputanswer: [],
            fenshuzhi: ''
        }
    },
    methods: {
        //返回个人中心
        returnclick: function () {
            this.$router.push({
            path: '/classstudy',
            query:{
                id:this.goodsId
            }
            })
        },
        //获取答案数据
        getAnswerData: function () {
                let topicArr = JSON.parse(this.examContent);
                this.fenshuzhi = this.fenshulll
                for (let val of topicArr) {
                    // delete val.answer;
                    if (val.type === '判断' || val.options.length === 2) {
                       val.value===val.answer[0]?val.isRight=true:val.isRight=false;
                        this.tfChoiceanswer.push(val);
                    } else if (val.type === '单选' && val.options.length === 4) {
                        val.value===val.answer[0]?val.isRight=true:val.isRight=false;
                        this.singleChoiceanswer.push(val);
                    } else if (val.type === '多选') {
                        let flag=true;
                       for(let v of val.answer){
                            if(val.value.indexOf(v)===-1){
                                flag=false;
                                break;
                            }
                       }
                       flag===true?val.isRight=true:val.isRight=false;
                        this.multipleChoiceanswer.push(val);
                    } else if (val.type === '填空') {
                        this.fillanswer.push(val);
                    }
                }

       
        }
        
    },
    created: function () {
        this.getAnswerData();
    },
    mounted: function () {
        document.title='习题答案：'+this.testTitle;
    },
}